export default "__VITE_ASSET__aiJAyd7n__"